import React from "react";

function RightArrowIcon() {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.714 6.70351L14.4647 0.293326C14.0835 -0.0977753 13.4651 -0.0977753 13.0838 0.293326C12.7024 0.684507 12.7024 1.31863 13.0838 1.70982L17.6661 6.41016H0.976444C0.437213 6.41016 0 6.85864 0 7.41175C0 7.96479 0.437213 8.41335 0.976444 8.41335H17.6661L13.084 13.1137C12.7026 13.5049 12.7026 14.139 13.084 14.5302C13.2746 14.7256 13.5245 14.8235 13.7744 14.8235C14.0243 14.8235 14.2742 14.7256 14.4649 14.5302L20.714 8.12C21.0953 7.72882 21.0953 7.09469 20.714 6.70351Z"
                fill="#B5B9BD"
            />
        </svg>
    );
}

export default RightArrowIcon;
